import { getToDay } from '@/utils/date';
import { message } from 'antd';
import { search_day, aggregate,search_day_export } from '@/services/costTx';
import moment from 'moment';
import { isAreaData } from '@/services/area';

let [startDate] = getToDay();

export default {
  namespace: 'newrateTx',
  state: {
    searchParams: {
      startDate: moment(startDate)
        .subtract(6, 'days')
        .format('YYYY-MM-DD'),
      endDate: moment(startDate).format('YYYY-MM-DD'),
      lineName: undefined,
      nameType: 'realLineType',
      lineType: 2,
      transportLineType: ['长途', '区域', '区内', '长线', '短线', '支线'],
      businessType: ['干线'],
      taskNo: undefined,
      taskAttribute: '',
      transportStatus: '',
    },

    page: 1,
    pageSize: 50,
    total: 0,

    onSearch: false,
    tableDatas: [],
    // calcWeightCount: 0, // 结算重量之和
    // volumeCount: 0, // 体积之和
    // actualCapacityCount: 0, // 实际运力之和
    // actualPositionCount: 0, // 实际仓位之和

    actualCapacity: 0, // 实际运力之和
    totalCalcWeightRate: 0, // 结算装载率
    totalCalcWeight: 0, // 结算重量之和
    totalVolume: 0, // 体积之和
    totalVolumeRate: 0, // 体积装载率

    exportVisible: false,

    access: {
      isHead: false,
      isArea: false,
      isCenter: true,
      code: '',
    },
  },

  effects: {
    // 分页查询
    *getDatas(_, { call, put, select }) {
      const newrateTx = yield select(({ newrateTx }) => newrateTx);
      try {
        const isDepartureArea = yield Promise.resolve(isAreaData(newrateTx?.searchParams?.departureCenter?.code));
        const isArrivalArea = yield Promise.resolve(isAreaData(newrateTx?.searchParams?.arrivalCenter?.code));
        const obj = handler(newrateTx,isDepartureArea,isArrivalArea);

        const result = yield call(search_day, obj);

        if (result?.code === 1 && result?.data) {
          yield put({
            type: 'updateState',
            payload: {
              tableDatas: result?.data?.rows || [],
              total: result.data?.total || 0,
            },
          });
        }
      } catch (err) {
        message.warn(err.message);
      }
    },
    // 按钮查询
    *search_day(_, { put, select }) {
      const newrateTx = yield select(({ newrateTx }) => newrateTx);

      try {
        const isDepartureArea = yield Promise.resolve(isAreaData(newrateTx?.searchParams?.departureCenter?.code));
        const isArrivalArea = yield Promise.resolve(isAreaData(newrateTx?.searchParams?.arrivalCenter?.code));
        const obj = handler(newrateTx,isDepartureArea,isArrivalArea);

        const [result, data] = yield Promise.all([search_day(obj), aggregate(obj)]);

        if (result?.code === 1 && result?.data) {
          yield put({
            type: 'updateState',
            payload: {
              tableDatas: result?.data?.rows || [],
              total: result.data?.total || 0,
            },
          });
        } else {
          yield put({
            type: 'updateState',
            payload: {
              tableDatas: [],
              total: 0,
            },
          });
        }
        if (data?.code === 1 && data?.data) {
          yield put({
            type: 'updateState',
            payload: {
              ...data?.data,
            },
          });
        } else {
          yield put({
            type: 'updateState',
            payload: {
              totalCalcWeight: 0,
              actualCapacity: 0,
              totalCalcWeightRate: 0,
              totalVolume: 0,
              totalVolumeRate: 0,
            },
          });
        }
      } catch (err) {
        message.warn(err.message);
      }
    },

    *exportDay({ payload }, { call, put, select }) {
      const newrateTx = yield select(({ newrateTx }) => newrateTx);
      try {
        const isDepartureArea = yield Promise.resolve(isAreaData(newrateTx?.searchParams?.departureCenter?.code));
        const isArrivalArea = yield Promise.resolve(isAreaData(newrateTx?.searchParams?.arrivalCenter?.code));
        const obj = handler(newrateTx,isDepartureArea,isArrivalArea);
        obj.columns = payload.choiceColumns;
        // obj.exportFlag = 1;

        const result = yield call(search_day_export, obj);

        if (result?.code === 1) {
          message.success('导出成功');
          yield put({
            type: 'updateState',
            payload: {
              exportVisible: false,
            },
          });
        }
      } catch (err) {
        message.warn(err.message);
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      // eslint-disable-next-line no-unused-vars
      const { nameTypeValue, nameTypes } = state.searchParams;
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },

    resetState(state) {
      return { state, tableDatas: [], offset: undefined };
    },
  },
};

const handler = (newrateTx, isDepartureArea, isArrivalArea) => {
  const { page, pageSize, searchParams, access } = newrateTx;
  const {
    departureCenter,
    arrivalCenter,
    transportLineType,
    businessType,
    startDate,
    endDate,
    ...others
  } = searchParams;

  if (!access.isHead) {
    if (departureCenter) {
      if (departureCenter.length === 0) {
        throw new Error('请选择出发站点/营运区');
      }
    } else {
      throw new Error('请选择出发站点/营运区');
    }
  }

  let obj = {
    page,
    pageSize,
    startDate: moment(startDate).format('YYYY-MM-DD'),
    endDate: moment(endDate).format('YYYY-MM-DD'),
    ...others,
  };

  // if (departureCenter) {
  //   obj.departureLevel = departureCenter.siteTypeCode === '900800' ? 1 : 2;
  //   obj.departureCode = departureCenter.code;
  // }
  // if (arrivalCenter) {
  //   obj.arrivalLevel = arrivalCenter.siteTypeCode === '900800' ? 1 : 2;
  //   obj.arrivalCode = arrivalCenter.code;
  // }
  if (departureCenter) {
    obj.departureLevel = isDepartureArea ? 1 : 2;
    obj.departureCode = departureCenter.code;
  }
  if (arrivalCenter) {
    obj.arrivalLevel = isArrivalArea ? 1 : 2;
    obj.arrivalCode = arrivalCenter.code;
  }

  if (transportLineType && transportLineType.length > 0) {
    obj.transportLineType = transportLineType.join(',');
  }
  if (businessType && businessType.length > 0) {
    obj.businessType = businessType.join(',');
  }
  return obj;
};
